var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { SecondaryText } from '../../cards/style';
var IconTag = function (_a) {
    var tag = _a.tag, Icon = _a.Icon;
    return (_jsxs(Container, { children: [Icon && Icon, _jsx(SecondaryText, { children: tag })] }));
};
export default IconTag;
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  color: var(--color-mono-60);\n  > div {\n    margin-left 5px;\n    color: inherit;\n  }\n"], ["\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  color: var(--color-mono-60);\n  > div {\n    margin-left 5px;\n    color: inherit;\n  }\n"])));
var templateObject_1;
//# sourceMappingURL=index.js.map